var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outWrapper"},[_c('Header'),_c('router-view',{key:_vm.$route.path}),_c('BackTop'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }